import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLSelectElement} [variant]
 * @property {HTMLElement} price
 * @property {HTMLElement} compareAt
 * @extends {Component<Refs>}
 */
class TrendSpotPurchase extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.selectVariant();
  }

  updatedCallback() {
    super.updatedCallback();
    this.selectVariant();
  }

  /** Reflect the native selector in the price and matching colour image. */
  selectVariant() {
    const option = this.refs.variant?.selectedOptions[0];
    if (!option) return;
    this.refs.price.textContent = option.dataset.price || '';
    this.refs.compareAt.textContent = option.dataset.compare || '';
    this.refs.compareAt.hidden = !option.dataset.compare;
    const grid = this.closest('.ts-product-grid');
    if (!grid) return;
    for (const panel of grid.querySelectorAll('[data-jacket-image], [data-scarf-image]')) {
      const color = panel.dataset.jacketImage || panel.dataset.scarfImage;
      panel.hidden = color !== option.dataset.color;
    }
  }
}

if (!customElements.get('trendspot-purchase')) {
  customElements.define('trendspot-purchase', TrendSpotPurchase);
}
